import {
  getFeedPostsForUser,
  getGetFeedPostsForUserQueryKey,
} from "@/orval/gen"
import { DefaultInfiniteList } from "../../../../../-components/InfiniteList"
import { useDefaultSuspenseInfiniteQuery } from "../../../../../utils/useDefaultSuspenseInfiniteQuery"
import { FeedPostCard } from "./FeedPostCard"

interface Props {
  subscribed: boolean
}

export function FeedPostsForUserList({ subscribed }: Props) {
  return (
    <DefaultInfiniteList
      gap="md"
      align="center"
      queryResult={useDefaultSuspenseInfiniteQuery(
        getFeedPostsForUser,
        (pageRequest) => ({
          ...pageRequest,
          subscribed,
        }),
        {
          queryKey: getGetFeedPostsForUserQueryKey({ subscribed }),
        }
      )}
      renderItem={({ entity }) => (
        <FeedPostCard hideComments={"collapsed"} feedPost={entity} />
      )}
    />
  )
}
